export default __webpack_public_path__ + "static/media/inyectorespbm.aff8c68a.png";